// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "../dist/js/" + {"119":"store","485":"vue"}[chunkId] + ".js?id=" + {"119":"c2f45c378161acbaa249","485":"f531fda5a828da2c753e"}[chunkId] + "";
};